import { useEffect, useState } from 'react';

import { useLoggedInEmployeeProfile } from '~/components/Auth';
import { getUserLastLogin } from '~/data/user';
import { People } from '~/services/Http';

export interface UseLegacyUserProfileOutput {
  employeeProfile: People.EmployeeProfileDto;
  lastLoginTime: string;
  openDialogName: string;
  dialogOpenChange: (name: string) => void;
  resetDialog: () => void;
}

export const useLegacyUserProfile = (): UseLegacyUserProfileOutput => {
  const employeeProfile = useLoggedInEmployeeProfile();
  const [lastLoginTime, setLastLoginTime] = useState('');
  const [openDialogName, setOpenDialogName] = useState('');

  useEffect(() => {
    let isMounted = true;
    if (employeeProfile.username) {
      getUserLastLogin(employeeProfile.username).then((timestamp) => {
        if (isMounted) {
          setLastLoginTime(timestamp);
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [employeeProfile]);

  const dialogOpenChange = (name: string) => {
    setOpenDialogName(name);
  };

  const resetDialog = () => {
    setOpenDialogName('');
  };

  return {
    employeeProfile,
    lastLoginTime,
    openDialogName,
    dialogOpenChange,
    resetDialog,
  };
};
